/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseFromJSON(json) {
    return StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetsCount': !exists(json, 'assets_count') ? undefined : json['assets_count'],
        'assetsTotal': !exists(json, 'assets_total') ? undefined : json['assets_total'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}
export function StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'assets_count': value.assetsCount,
        'assets_total': value.assetsTotal,
        'status': value.status,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus;
(function (StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus) {
    StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus["CAPTURED"] = "ASSET_STATUS_CAPTURED";
    StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus["INVALID"] = "ASSET_STATUS_INVALID";
    StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus["MOVED"] = "ASSET_STATUS_MOVED";
    StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus["PLACED"] = "ASSET_STATUS_PLACED";
    StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus["REMOVED"] = "ASSET_STATUS_REMOVED";
})(StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus || (StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhaseStatus = {}));
//# sourceMappingURL=StreemApiAnalyticEventGuidedExperiencePhaseUpdatedAssetCapturePhase.js.map